import React, { useEffect, useState } from 'react';
import LdcApi from '../../../LdcApis';
import { Table } from 'react-bootstrap';
import { DatePicker, Empty, Skeleton } from 'antd';
import dayjs from 'dayjs';
const Report = () => {
  useEffect(() => {
    document.title = 'Monthly Reconciliation';
  }, []);
  //   const [date, setDate] = useState(moment(new Date()).format('YYYY-MM-DD'));
  const [finalDateRange, setFinalDateRange] = useState({
    startDate: '',
    endDate: '',
  });

  const [DateRangesss, setDateRangess] = useState({
    startDate: '',
    endDate: '',
  });
  const [loading, setLoading] = useState(null);
  const [eodMonthlyData, setEodMonthlyData] = useState([]);
  const [totals, setTotals] = useState({
    amEx: 0,
    cash: 0,
    deposit: 0,
    opayo: 0,
    otherCards: 0,
    total: 0,
  });

  // const [monthTotal, setMonthTotal] = useState(0);
  const { RangePicker } = DatePicker;
  const dateFormat = 'DD/MM/YYYY';
  const now = new Date();
  const threeMonthsAgo = new Date();
  threeMonthsAgo.setMonth(threeMonthsAgo.getMonth() - 1);
  // function formatDateToYYYYMMDD(date) {
  //   // Ensure the parameter is a Date object; if not, use the current date
  //   const currentDate = date instanceof Date ? date : new Date();
  //   // Extract year, month, and day
  //   const year = currentDate.getFullYear();
  //   const month = (currentDate.getMonth() + 1).toString().padStart(2, "0"); // Months are zero-based
  //   const day = currentDate.getDate().toString().padStart(2, "0");
  //   // Format the date
  //   const formattedDate = `${year}-${month}-${day}`;
  //   return formattedDate;
  // }
  // Set the default value for the RangePicker
  const defaultValue = [dayjs(now).startOf('month'), dayjs(now).endOf('month')];

  // const defaultValue = [
  //   dayjs(formatDateToYYYYMMDD(threeMonthsAgo)),
  //   dayjs(formatDateToYYYYMMDD(now)),
  // ]; // RangePicker takes an array of two moment objects
  const [selectedRange, setSelectedRange] = useState(defaultValue);

  // useEffect(() => {
  //   const monthTotals = eodMonthlyData.reduce(
  //     (a, b) => (a === undefined ? 0 : a) + (b === undefined ? 0 : b.amount),
  //     0
  //   );
  //   setMonthTotal(monthTotals);
  // }, [eodMonthlyData]);
  // useEffect(() => {
  //   const monthTotals = eodMonthlyData.reduce(
  //     (sum, item) => sum + (item.total || 0),
  //     0
  //   );
  //   setMonthTotal(monthTotals);
  // }, [eodMonthlyData]);

  const onChange = (dates, dateStrings) => {
    if (!dates || dates.length !== 2) return;

    const startOfMonth = dates[0].startOf('month').format('YYYY-MM-DD');
    const endOfMonth = dates[1].endOf('month').format('YYYY-MM-DD');

    setFinalDateRange({
      startDate: startOfMonth,
      endDate: endOfMonth,
    });
  };

  function generateDateRange(startDate, endDate) {
    const start = dayjs(startDate);
    const end = dayjs(endDate);
    const dateArray = [];

    let current = start;
    while (current.isBefore(end) || current.isSame(end)) {
      dateArray.push(current.format('YYYY-MM-DD'));
      current = current.add(1, 'day');
    }

    return dateArray;
  }

  useEffect(() => {
    const today = dayjs();
    setDateRangess({
      startDate: today.startOf('month').format('YYYY-MM-DD'),
      endDate: today.endOf('month').format('YYYY-MM-DD'),
    });
  }, []);

  useEffect(() => {
    setLoading(true);
    let fistDate = finalDateRange.startDate.split('/').reverse().join('/');
    let endDate = finalDateRange.endDate.split('/').reverse().join('/');

    LdcApi({
      method: 'GET',
      url: `Invoice/GetMonthlyReconciliationReport?startdate=${finalDateRange.startDate === '' ? DateRangesss.startDate : fistDate}&enddate=${
        finalDateRange.startDate === '' ? DateRangesss.endDate : endDate
      }`,
    })
      .then((res) => {
        console.log('res', res);
        console.log('fistDate, endDate', fistDate, endDate);
        if (Array.isArray(res?.data?.data) && res.data.data.length > 0) {
          // setEodMonthlyData(res.data.data);
          const rawData = res.data.data || [];
          const allDates = generateDateRange(
            finalDateRange.startDate === '' ? DateRangesss.startDate : fistDate,
            finalDateRange.endDate === '' ? DateRangesss.endDate : endDate
          );

          // Convert to YYYY-MM-DD for matching
          const dataByDate = {};
          rawData.forEach((item) => {
            const dateKey = dayjs(item.paymentDate).format('YYYY-MM-DD');
            dataByDate[dateKey] = item;
          });

          // Fill missing dates with default values
          const filledData = allDates.map((date) => {
            return {
              paymentDate: date,
              ...(dataByDate[date] || {
                otherCards: '',
                amEx: '',
                deposit: '',
                opayo: '',
                cash: '',
                total: '',
              }),
            };
          });

          setEodMonthlyData(filledData);
          const summedTotals = filledData.reduce(
            (acc, curr) => {
              acc.amEx += Number(curr.amEx || 0);
              acc.cash += Number(curr.cash || 0);
              acc.deposit += Number(curr.deposit || 0);
              acc.opayo += Number(curr.opayo || 0);
              acc.otherCards += Number(curr.otherCards || 0);
              acc.total += Number(curr.total || 0);
              return acc;
            },
            { amEx: 0, cash: 0, deposit: 0, opayo: 0, otherCards: 0, total: 0 }
          );

          setTotals(summedTotals);

          setLoading(false);
        } else {
          setLoading(null);
        }
      })
      .catch((err) => {
        setLoading(null);
      });
  }, [finalDateRange, DateRangesss]);

  return (
    <div>
      <div className='d-flex align-items-center my-4' style={{ color: 'gray' }}>
        <b className='mr-2'>Date Range : </b>
        <RangePicker
          format={dateFormat}
          onChange={onChange}
          defaultValue={selectedRange}
        />
      </div>
      {loading === true ? (
        <>
          <Skeleton />
        </>
      ) : (
        <>
          {loading === null || false ? (
            <>
              <Empty />
            </>
          ) : (
            <>
              {' '}
              <Table
                responsive
                className='table table-bordered'
                id='bootstrap_table'
              >
                <thead id='bootstrap_table_head'>
                  <tr>
                    <th scope='col' style={{ minWidth: 200 }}>
                      Date
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>Other Cards</span>
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>AmEx</span>
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>Deposit</span>
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>Opayo</span>
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>Cash</span>
                    </th>
                    <th scope='col ' style={{ minWidth: 200 }}>
                      <span id='eod_table_heading'>Total</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {eodMonthlyData.map((el, i) => (
                    <tr key={i}>
                      <td>{dayjs(el.paymentDate).format('DD/MM/YYYY')}</td>
                      <td>
                        {el.otherCards !== ''
                          ? `£${el.otherCards.toFixed(2)}`
                          : ''}
                      </td>
                      <td>{el.amEx !== '' ? `£${el.amEx.toFixed(2)}` : ''}</td>
                      <td>
                        {el.deposit !== '' ? `£${el.deposit.toFixed(2)}` : ''}
                      </td>
                      <td>
                        {el.opayo !== '' ? `£${el.opayo.toFixed(2)}` : ''}
                      </td>
                      <td>{el.cash !== '' ? `£${el.cash.toFixed(2)}` : ''}</td>
                      <td>
                        {el.total !== '' ? `£${el.total.toFixed(2)}` : ''}
                      </td>
                    </tr>
                  ))}

                  <tr className='border_top'>
                    <td style={{ fontWeight: 'bold' }}>TOTAL</td>

                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.otherCards.toFixed(2)}
                    </td>

                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.amEx.toFixed(2)}
                    </td>
                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.deposit.toFixed(2)}
                    </td>

                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.opayo.toFixed(2)}
                    </td>

                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.cash.toFixed(2)}
                    </td>

                    <td style={{ fontWeight: 'bold' }}>
                      £{totals.total.toFixed(2)}
                    </td>

                    {/* <td style={{ fontWeight: 'bold' }}>£{eodMonthlyData.cash.toFixed(2)}</td> */}
                  </tr>
                </tbody>
              </Table>{' '}
            </>
          )}
        </>
      )}
    </div>
  );
};

export default Report;
